<template>
  <div>
    <navHeader />
    <div class="container-lg mt-5">
      <div class="row">
        <div class="col-12 col-md-12 col-lg-12">
          <div class="p-3">
            <h5>Daily Notes</h5>
            <h2 class="main-title">{{ content.title }}</h2>
            <p class="text-muted m-0">{{ FormatDate(content.date) }}</p>
            <div class="row">
              <div class="col-lg-8 col-md-8 col-12">
                <table
                  class="table table-bordered stock-reco-card"
                  v-if="
                    content.stockRecommendation.stockSymbol != '' &&
                    content.stockRecommendation.entryPrice != '' &&
                    content.stockRecommendation.targetPrice != '' &&
                    content.stockRecommendation.potentialUpside != ''
                  "
                >
                  <thead class="stock-reco-header">
                    <tr>
                      <th colspan="4" class="text-center">Stock Recommendation</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-center">
                        Stock
                        <h4 class="stock-label">{{ content.stockRecommendation.stockSymbol }}</h4>
                      </td>
                      <td class="text-center">
                        Entry Price
                        <h4 class="stock-label">{{ content.stockRecommendation.entryPrice }}</h4>
                      </td>
                      <td class="text-center">
                        Target Price
                        <h4 class="stock-label">{{ content.stockRecommendation.targetPrice }}</h4>
                      </td>
                      <td class="text-center">
                        Potential Upside
                        <h4 class="stock-label">{{ content.stockRecommendation.potentialUpside }}</h4>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <h5 class="sub-title-page">{{ content.articleTitle }}</h5>
             <bullMeter :slider="ConvertValue(content.slider)" v-if="content.showBullMeter == 'True'"/> 
            <div>
              <p class="text-muted" v-html="content.stockRecommendation.article"></p>
            </div>
            <div v-for="(item, index) in content.templates" :key="index">
              <div v-if="item.contentType == 'string'" class="content-string">
                <p class="text-muted" v-html="item.content"></p>
              </div>

              <div v-if="item.contentType == 'date'">
                <p class="text-muted" v-html="FormatDate(item.content)"></p>
              </div>

              <div v-if="item.contentType == 'image'" class="image-umbraco">
                <b-img
                  class="img-thumbnail"
                  :src="'data:image/jpeg;base64,' + item.content"
                  fluid-grow
                  alt="Fluid-grow image"
                ></b-img>
              </div>
              <div class="table table-umbraco" v-if="item.contentType == 'table'">
                <p v-html="item.content"></p>
              </div>
              <div v-if="item.contentType == 'link'" class="content-string">
                <p class="text-muted" v-html="item.content"></p>
              </div>
              <bullMeter
                  :slider="ConvertValue(item.content)"
                  v-if="item.contentType == 'slider'"
                />
            </div>
            <a href="javascript:void(0)" @click="ViewArchive()">View Daily Notes Archive</a>
            <Disclaimer />
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import navHeader from "../../ResearchPages/NavHeader";
import Disclaimer from "../ReportsPages/Disclaimer";
import { mapState } from "vuex";
import Footer from "../Footer";
import moment from "moment";
import bullMeter from "../BullMeter/BullMeter.vue";

export default {
  components: {
    Disclaimer,
    navHeader,
    Footer,
    bullMeter,
 
  },

  data() {
    return { showProgressbar: false };
  },
  computed: {
    ...mapState({
      content: state => state.philstocksResearch.dailyNote
    }),
  },

  methods: {
    GoogleAnalytics() {
      this.$gtag.event("DailyNotes", { method: "Google" });
    },
    ViewArchive() {
      this.$router.push("/Reports/Archive/DailyNotes");
    },

    ConvertValue(data) {
      var value = parseInt(data);
     return value;
    },
    FormatDate(date) {
      var result = "";
      if (date == "0001-01-01T00:00:00") {
        result = "--";
      } else {
        result = moment(date).format("MMMM DD, YYYY");
      }
      return result;
    },

    async GetDailyNotesContent(data) {
      var isResponseError = false;
      this.isDataLoaded = true;
      var _this = this;
      await this.$store
        .dispatch("philstocksResearch/GetDailyNotes", data)
        .catch(function(error) {
          console.log(error);
          _this.isDataLoaded = false;

          isResponseError = false;
        });

      if (!isResponseError) {
        _this.isDataLoaded = false;
      }
    }
  },
  async mounted() {
    this.GetDailyNotesContent(this.$route.query.date);
  }
};
</script>

<style></style>
